import { GridContainer, GridItem, GridRow } from "@tvg/fuse-design/responsive-grid";
import { SpacingWrapper } from "@tvg/fuse-design/spacing-wrapper";
import { TextBlock as FuseTextBlock } from "@tvg/fuse-design/text-block";

import useRender from "client/hooks/useRender";
import React from "react";
import styled from "styled-components";
import { AmpTextBlock } from "types/amplience";
import { backgroundConfig } from "./config";

export interface TextBlockProps {
  config: AmpTextBlock;
  gridWrapper?: boolean;
  noSidePadding?: boolean;
}

const StyledTextBlock = styled(FuseTextBlock).withConfig({ shouldForwardProp: (prop) => prop !== "noSidePadding" })`
  ${({ noSidePadding }) =>
    noSidePadding &&
    `&& {
        padding-left: 0; 
        padding-right: 0;
      }
    `};
`;

export const TextBlock: React.FC<TextBlockProps> = ({ config, gridWrapper = true, noSidePadding = false }) => {
  const render = useRender();

  const textHTML = { __html: render(config.text, config.background) };

  return gridWrapper ? (
    <SpacingWrapper marginBottom="l">
      <GridContainer>
        <GridRow>
          <GridItem xxs="12" l="8" colStart-l="3">
            <StyledTextBlock
              background={config.background && backgroundConfig[config.background].propValue}
              paddingTop={false}
              paddingBottom={false}
              blackBorder={config.blackBorder}
              noSidePadding={noSidePadding}
              dataTestId="content-text-block"
            >
              <div dangerouslySetInnerHTML={textHTML} />
            </StyledTextBlock>
          </GridItem>
        </GridRow>
      </GridContainer>
    </SpacingWrapper>
  ) : (
    <StyledTextBlock
      background={config.background && backgroundConfig[config.background].propValue}
      paddingTop={false}
      paddingBottom={false}
      blackBorder={config.blackBorder}
      noSidePadding={noSidePadding}
      dataTestId="content-text-block"
    >
      <div dangerouslySetInnerHTML={textHTML} />
    </StyledTextBlock>
  );
};
